import React from 'react'

export default function UnauthorizedComponent() {
  return (
    <div>unauthorized</div>
  )
}
